import { render } from "./AlertView.vue?vue&type=template&id=320607c1&scoped=true"
import script from "./AlertView.vue?vue&type=script&lang=js"
export * from "./AlertView.vue?vue&type=script&lang=js"

import "./AlertView.vue?vue&type=style&index=0&id=320607c1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320607c1"]])

export default __exports__